import { getAccountName } from '../../components/ConfirmationSection/util';
import config from '../../config';
import { navigateToExternal } from '../../core/util';
import { accountTypes, removeSlash } from '../../flows/shared/utils';

export const navigateToLoginFromChecklist = (route = '') => {
  const domainURL = config('returnUrlPrefix');
  const cleanDomainURL = removeSlash(domainURL);
  const cleanPathname = removeSlash(window.location.pathname);
  navigateToExternal(
    `${config(
      'clxUrl'
    )}/usis/login/?pdurl=/clx-tk/token-exchange/redirect/nasu?sdurl=${cleanDomainURL}${cleanPathname}${route}${
      window.location.search
    }`
  );
};

export const getTaxableChecklistHeaderText = accountType => {
  const accountname = getAccountName(accountType);

  const headerText = {
    UGMA_UTMA: `an ${accountname}`,
    INDIVIDUAL: `an ${accountname} General Investing`,
    JOINT_TENANT: `a ${accountname} Owner General Investing`
  }[accountType];

  return headerText;
};

export const getTaxableChecklistSubHeaderText = accountType => {
  const isIndividual = accountType === accountTypes.INDIVIDUAL;

  const isIndividualOrJoint =
    accountType === accountTypes.INDIVIDUAL ||
    accountType === accountTypes.JOINT;

  const ownerType = isIndividual
    ? 'one registered owner'
    : 'multiple registered owners';

  return isIndividualOrJoint
    ? `Set up an account with ${ownerType} to invest in mutual funds managed by T. Rowe Price. `
    : `Start a child on the path to investing with an ${getAccountName(
        accountType
      )} account `;
};

export const getCorrespondingBRKAccLinks = accountType => {
  const brkAccountType = {
    UGMA_UTMA: 'ugma-utma',
    INDIVIDUAL: 'individual',
    JOINT_TENANT: 'joint'
  }[accountType];

  return `${config(
    'returnUrlPrefix'
  )}personal-investing/new-account/setup/account-info/brk-checklist/${brkAccountType}`;
};

export const isNonUGMATaxable = accountType => {
  if (
    accountType === accountTypes.INDIVIDUAL ||
    accountType === accountTypes.JOINT ||
    accountType === accountTypes.TRUST
  )
    return true;
  return false;
};

export const getChecklistSSNText = accountType => {
  return `Social Security ${
    {
      INDIVIDUAL: 'number',
      JOINT_TENANT: 'numbers of all registered account owners',
      UGMA_UTMA: 'numbers'
    }[accountType]
  }`;
};

export const getStepsSectionSecondHeader = accountType => {
  const accountname = getAccountName(accountType);
  return `${
    {
      INDIVIDUAL: `Choose Mutual Funds for your ${accountname} account`,
      JOINT_TENANT: `Choose Mutual Funds for your ${accountname} Owner account`,
      UGMA_UTMA: `Choose Mutual Funds for your ${accountname} account`
    }[accountType]
  }`;
};

export const getStepsSectionThirdHeader = accountType => {
  return `${
    {
      INDIVIDUAL: 'Provide personal details',
      JOINT_TENANT:
        'Provide personal details for all registered account owners',
      UGMA_UTMA: 'Provide personal details for yourself and the minor'
    }[accountType]
  }`;
};

export const taxableTransferTypeHeaderDisplay = {
  INDIVIDUAL: 'an Individual account',
  JOINT_TENANT: 'a Joint Tenant account',
  UGMA_UTMA: 'an UGMA/UTMA'
};

export const taxableTransferTypeSubHeaderDisplay = {
  INDIVIDUAL: 'Individual accounts',
  JOINT_TENANT: 'Joint Tenant accounts',
  UGMA_UTMA: 'UGMA/UTMAs'
};

export const taxableTransferTypeDisplay = {
  INDIVIDUAL: 'Individual',
  JOINT_TENANT: 'Joint Tenant',
  UGMA_UTMA: 'UGMA/UTMA'
};

export const taxableTransferLinkText = {
  INDIVIDUAL: 'individual',
  JOINT_TENANT: 'joint',
  UGMA_UTMA: 'ugma-utma'
};
